import client from "./client";

export interface EmergencyContact {
  id: string;
  employee_id: string;
  name: string;
  relationship: string | null;
  phone: string;
  phone_secondary: string | null;
  email: string | null;
  address: string | null;
  is_primary: boolean;
  notes: string | null;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export interface EmergencyContactCreate {
  name: string;
  relationship?: string | null;
  phone: string;
  phone_secondary?: string | null;
  email?: string | null;
  address?: string | null;
  is_primary?: boolean;
  notes?: string | null;
  sort_order?: number;
}

export type EmergencyContactUpdate = Partial<EmergencyContactCreate>;

const base = (employeeId: string) =>
  `/employees/${employeeId}/emergency-contacts`;

export async function listContacts(
  employeeId: string
): Promise<EmergencyContact[]> {
  const res = await client.get<EmergencyContact[]>(base(employeeId));
  return res.data;
}

export async function createContact(
  employeeId: string,
  data: EmergencyContactCreate
): Promise<EmergencyContact> {
  const res = await client.post<EmergencyContact>(base(employeeId), data);
  return res.data;
}

export async function updateContact(
  employeeId: string,
  contactId: string,
  data: EmergencyContactUpdate
): Promise<EmergencyContact> {
  const res = await client.put<EmergencyContact>(
    `${base(employeeId)}/${contactId}`,
    data
  );
  return res.data;
}

export async function deleteContact(
  employeeId: string,
  contactId: string
): Promise<void> {
  await client.delete(`${base(employeeId)}/${contactId}`);
}
